<template>
    <div v-if="!dialog">
        <h2 v-text="typeTitle" />

        <template v-if="!editOnly">
            <div v-if="terms === null">
                {{$translate('Loading...')}} <v-progress-circular indeterminate color="primary" />
            </div>
            <div v-else v-html="terms" />
        </template>

        <v-btn v-if="hasEditPermission" @click="showEditDialog = true" color="primary" text>{{$translate('Edit conditions')}}</v-btn>

        <v-dialog v-model="showEditDialog" max-width="850px" scrollable>
            <v-card>
                <v-card-title class="headline" v-text="typeTitle" />

                <v-card-text style="overflow-y: auto">
                    <editor v-model="changedTerms" :bubble="true" style="margin-top: 50px" />
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn @click="save" color="primary" :loading="saving" :disabled="terms == changedTerms">{{$translate('Save')}}</v-btn>

                    <v-btn
                        text
                        color="primary"
                        @click="showEditDialog = false"
                    >
                        {{$translate('Close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <v-dialog v-else v-model="showDialog" max-width="850px" scrollable>
        <v-card style="overflow-y: auto">
            <v-card-title class="headline" v-text="typeTitle" />

            <v-card-text>
                <div v-if="terms === null">
                    {{$translate('Loading...')}} <v-progress-circular indeterminate color="primary" />
                </div>
                <div v-else v-html="terms" />
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    text
                    color="primary"
                    @click="showDialog = false"
                >
                    {{$translate('Close')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

const TERMS_TYPES = [
    {id: 'general', name: 'General terms and conditions'},
    {id: 'name', name: 'Privacy Policy'}
];

import Editor from '../components/Editor.vue'
export default {
    name: 'zoezi-terms',

    zoezi: {
        title: 'Terms',
        icon: 'mdi-check'
    },
    components: {
        Editor
    },
    props: {
        type: {
            title: 'Type of condition',
            type: String,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return TERMS_TYPES.map(t => ({...t, name: window.$translate(t.name)}));
                },
                text: 'name',
                value: 'id',
                multiple: false
            },
            default: 'general'
        },
        dialog: {
            title: 'Show in dialog',
            type: Boolean,
            default: false
        },
        editOnly: {
            title: 'Show editing link only',
            type: Boolean,
            default: false
        },
    },

    data: () => ({
        terms: null,
        changedTerms: null,
        showDialog: false,
        showEditDialog: false,
        saving: false
    }),

    watch: {
        dialog: {
            immediate: true,
            handler(dialog) {
                if (dialog) {
                    this.showDialog = true;
                }

                this.getTerms();
            }
        },
        showDialog(dialog) {
            if (!dialog) {
                this.$emit('hidden');
            }
        },
        showEditDialog(show) {
            if (show) {
                this.changedTerms = this.terms;
            }
        }
    },

    computed: {
        hasEditPermission() {
            return this.$store.state?.user?.permissions?.find(x => x == 'Settings');
        },
        typeTitle() {
            return this.$translate(TERMS_TYPES.find(t => t.id == this.type)?.name);
        }
    },

    methods: {
        getTerms() {
            this.$api.get('/api/public/terms/get', {type: this.type, is_global: false}).then(terms => this.terms = terms);
        },
        save() {
            this.saving = true;
            this.$api.post('/api/terms/change', {text: this.changedTerms}, {type: this.type, is_global: false}).then(() => {
                this.saving = false;
                this.showEditDialog = false;
                this.getTerms();
            })
        }
    }
}
</script>
